export const GLOBALS = {
	API_STATUSES: {
		NOT_CALLED: 'NOT_CALLED',
		REQUEST: 'REQUEST',
		SUCCESS: 'SUCCESS',
		FAILURE: 'FAILURE',
		TIMEOUT: 'TIMEOUT',
	},

	TOAST_TIMEOUT: {
		DEFAULT: 5000,
		UNSET: 'UNSET',
	},
	NATIONAL_ID_LENGTH: 10,
};
